import { ToggleButton } from '@progress/kendo-react-dateinputs';
import { ClockOutline } from '../../../../../icons/icons';
import { useAppDispatch, useAppSelector } from '../../../../hooks/store-hooks';
import { setSetting } from '../../../../state/slices/settings-slice';
import { store } from '../../../../state/store';

export function ClocksToolbarItem() {
    const clocksEnabled = useAppSelector((x) => x.settings.worldClocks.enabled);
    const dispatch = useAppDispatch();

    return (
        <ToggleButton
            togglable
            selected={clocksEnabled}
            style={{
                width: 27,
                height: 27
            }}
            title="Clocks"
            id="toolbar-clocks"
            data-tooltip-bottom
            className="k-rounded-full"
            svgIcon={ClockOutline}
            onClick={() => {
                const settings = store.getState().settings.worldClocks;
                dispatch(
                    setSetting('worldClocks', {
                        ...settings,
                        enabled: !settings.enabled
                    })
                );
            }}
        />
    );
}
